import * as Sentry from '@sentry/react';

export default Sentry;
